<a
                href="{{url}}"
                target="_blank"
                class="fab fa-twitter"></a>